import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Principal.module.scss';
import {
  EnvironmentOutlined,
  WhatsAppOutlined,
  ClockCircleOutlined,
  MailOutlined,
  SafetyCertificateOutlined,
  SendOutlined,
  CustomerServiceOutlined,
  ShopOutlined,
  CarOutlined,
  ArrowRightOutlined,
} from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { getAllOfertasActivas } from '../../store/MSCommerce/Ofertas/thunks';
import { AppState } from '../../store';
import { OfertaCard } from '../Commerce/Ofertas/components/OfertaCard';
import Contact from '../../Services/contact';

const Principal: React.FC = () => {
  const dispatch = useDispatch<any>();
  const history = useHistory();
  const ofertas = useSelector((state: AppState) => state.ofertasAction.ofertas);

  useEffect(() => {
    dispatch(getAllOfertasActivas());
  }, [dispatch]);

  const ofertasDestacadas = (ofertas ?? []).slice(0, 3);

  return (
    <div className={styles.dashboard}>


      {/* Hero */}
      <section className={styles.dashboard__hero}>
        <div className={styles['dashboard__hero-overlay']} />
        <div className={styles['dashboard__hero-content']}>
          <p className={styles['dashboard__hero-subtitle']}>Bienvenida a</p>
          <h1 className={styles['dashboard__hero-title']}>Glow Skin</h1>
          <p className={styles['dashboard__hero-description']}>
            Descubre nuestra colección de productos de cuidado facial,
            elaborados con los mejores ingredientes para realzar tu belleza natural.
          </p>
        </div>
      </section>

      {/* Confianza */}
      <section className={styles.dashboard__trust}>
        <div className={styles['dashboard__trust-card']}>
          <div className={styles['dashboard__trust-item']}>
            <span className={styles['dashboard__trust-iconWrap']}>
              <SafetyCertificateOutlined />
            </span>
            <div>
              <p className={styles['dashboard__trust-itemTitle']}>Productos 100% originales</p>
              <p className={styles['dashboard__trust-itemText']}>Garantizados y verificados</p>
            </div>
          </div>

          <div className={styles['dashboard__trust-divider']} />

          <div className={styles['dashboard__trust-item']}>
            <span className={styles['dashboard__trust-iconWrap']}>
              <SendOutlined />
            </span>
            <div>
              <p className={styles['dashboard__trust-itemTitle']}>Envíos a todo Ecuador</p>
              <p className={styles['dashboard__trust-itemText']}>A domicilio o por Servientrega</p>
            </div>
          </div>

          <div className={styles['dashboard__trust-divider']} />

          <div className={styles['dashboard__trust-item']}>
            <span className={styles['dashboard__trust-iconWrap']}>
              <CustomerServiceOutlined />
            </span>
            <div>
              <p className={styles['dashboard__trust-itemTitle']}>Asesoría personalizada</p>
              <p className={styles['dashboard__trust-itemText']}>Te ayudamos a elegir</p>
            </div>
          </div>
        </div>
      </section>

      {/* Ofertas destacadas */}
      {ofertasDestacadas.length > 0 && (
        <section className={styles.dashboard__ofertas}>
          <div className={styles['dashboard__ofertas-header']}>
            <p className={styles['dashboard__ofertas-subtitle']}>No te lo pierdas</p>
            <h2 className={styles['dashboard__ofertas-title']}>Ofertas del momento</h2>
          </div>

          <div className={styles['dashboard__ofertas-grid']}>
            {ofertasDestacadas.map(oferta => (
              <OfertaCard key={oferta.id} oferta={oferta} />
            ))}
          </div>

          <button
            className={styles['dashboard__ofertas-cta']}
            onClick={() => history.push('/ofertas')}
          >
            Ver todas las ofertas <ArrowRightOutlined />
          </button>
        </section>
      )}

      {/* Sobre nosotros */}
      <section className={styles.dashboard__info}>
        <div className={styles['dashboard__info-header']}>
          <h2 className={styles['dashboard__info-title']}>Sobre Nosotros</h2>
          <p className={styles['dashboard__info-subtitle']}>
            Cuidado de la piel con amor y dedicación
          </p>
        </div>

        <div className={styles['dashboard__info-grid']}>
          <div className={styles['dashboard__info-card']}>
            <EnvironmentOutlined className={styles['dashboard__info-icon']} />
            <h3 className={styles['dashboard__info-card-title']}>Ubicación</h3>
            <p className={styles['dashboard__info-card-text']}>Quito Sur, Ecuador</p>
          </div>
          <div className={styles['dashboard__info-card']}>
            <WhatsAppOutlined className={styles['dashboard__info-icon']} />
            <h3 className={styles['dashboard__info-card-title']}>Teléfono</h3>
            <p className={styles['dashboard__info-card-text']}>+593 93 937 5829</p>
          </div>
          <div className={styles['dashboard__info-card']}>
            <ClockCircleOutlined className={styles['dashboard__info-icon']} />
            <h3 className={styles['dashboard__info-card-title']}>Horario</h3>
            <p className={styles['dashboard__info-card-text']}>
              Lunes a Viernes 9:00 - 18:00
            </p>
          </div>
          <div className={styles['dashboard__info-card']}>
            <MailOutlined className={styles['dashboard__info-icon']} />
            <h3 className={styles['dashboard__info-card-title']}>Email</h3>
            <p className={styles['dashboard__info-card-text']}>
              samirachisaguano@gmail.com
            </p>
          </div>
        </div>
      </section>

      {/* Puntos y formas de entrega */}
      <section className={styles.dashboard__delivery}>
        <div className={styles['dashboard__delivery-header']}>
          <h2 className={styles['dashboard__delivery-title']}>¿Cómo recibir tu pedido?</h2>
          <p className={styles['dashboard__delivery-subtitle']}>
            Elige la opción que más te convenga
          </p>
        </div>

        <div className={styles['dashboard__delivery-grid']}>
          <div className={styles['dashboard__delivery-card']}>
            <ShopOutlined className={styles['dashboard__delivery-icon']} />
            <h3 className={styles['dashboard__delivery-card-title']}>Puntos de entrega</h3>
            <p className={styles['dashboard__delivery-card-text']}>
              Sábados en:
            </p>
            <ul className={styles['dashboard__delivery-list']}>
              <li>C.C. Quicentro Norte — 10:00 am</li>
              <li>C.C. El Recreo — 11:00 am y 4:00 pm</li>
            </ul>
          </div>
          <div className={styles['dashboard__delivery-card']}>
            <CarOutlined className={styles['dashboard__delivery-icon']} />
            <h3 className={styles['dashboard__delivery-card-title']}>Envío a domicilio</h3>
            <p className={styles['dashboard__delivery-card-text']}>
              En Quito coordinamos tu pedido a través de Uber, directo a tu puerta.
            </p>
          </div>
          <div className={styles['dashboard__delivery-card']}>
            <SendOutlined className={styles['dashboard__delivery-icon']} />
            <h3 className={styles['dashboard__delivery-card-title']}>Envío nacional</h3>
            <p className={styles['dashboard__delivery-card-text']}>
              ¿Estás en otra provincia? Te lo enviamos mediante Servientrega.
            </p>
          </div>
        </div>
      </section>

      {/* CTA WhatsApp */}
      <section className={styles.dashboard__cta}>
        <h2 className={styles['dashboard__cta-title']}>¿Tienes dudas sobre algún producto?</h2>
        <p className={styles['dashboard__cta-text']}>
          Escríbenos directo y te ayudamos a elegir lo mejor para tu piel.
        </p>
        <a
          className={styles['dashboard__cta-btn']}
          href={`https://wa.me/${Contact.WHATSAPP_NUMERO}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <WhatsAppOutlined /> Escríbenos por WhatsApp
        </a>
      </section>

    </div>
  );
};

export default Principal;